<template>
  <div class="flex flex-row justify-between mb-0">
    <div>
      <div class="pb-1 font-size-sm font-weight-bold mb-1 border-bottom">
        <span class="badge badge-success font-size-sm">
        {{ $store.getters.results.filter((e) => e.visible && !e.compared).length }}
        </span> Casinò trovati
      </div>
    </div>
   <!--  <div class="flex flex-row">
      <button
        @click="order('nome')"
        class="btn btn-sm btn-outline-black mr-1"
        :class="{
          'btn-secondary': this.nome.active,
        }"
      >
        Per nome
        <i
          class="fe"
          :class="{
            'fe-arrow-up':
              this.nome.active && this.nome.order == 'ASC',
            'fe-arrow-down':
              this.nome.active && this.nome.order == 'DESC',
          }"
        ></i>
      </button>
      <button
        :class="{
          'btn-secondary': this.nome.active,
        }"
        @click="order('playthrough')"
        class="btn btn-sm btn-outline-black mr-1"
      >
        Per playthrough
        <i
          class="fe"
          :class="{
            'fe-arrow-up':
              this.playthrough.active && this.playthrough.order == 'ASC',
            'fe-arrow-down':
              this.playthrough.active && this.playthrough.order == 'DESC',
          }"
        ></i>
      </button>
      <button
        :class="{
          'btn-secondary': this.nome.active,
        }"
        @click="order('bonus_massimo')"
        class="btn btn-sm btn-outline-black"
      >
        Per bonus benvenuto
        <i
          class="fe"
          :class="{
            'fe-arrow-up':
              this.bonus_massimo.active && this.bonus_massimo.order == 'ASC',
            'fe-arrow-down':
              this.bonus_massimo.active && this.bonus_massimo.order == 'DESC',
          }"
        ></i>
      </button>
    </div> -->
  </div>
</template>

<script>
import store from '../store';
export default {
  name: 'CasinoResultsOrdering',
  store,
  props: ['total'],
  data: function() {
    return {
      nome: { order: 'DESC', active: false },
      playthrough: { order: undefined, active: false },
      bonus_massimo: { order: undefined, active: false },
    };
  },
  mounted() {
  },

  methods: {
    order(orderType) {
      store.commit(
        'setResults',
        store.getters.results.sort((a, b) => {
          return a[orderType] < b[orderType]
            ? this[orderType].order == 'ASC'
              ? 1
              : -1
            : a[orderType] > b[orderType]
            ? this[orderType].order == 'ASC'
              ? -1
              : 1
            : 0;
        })
      );

      this[orderType].order =
        this[orderType].order == 'ASC' || this[orderType].order == undefined
          ? 'DESC'
          : 'ASC';

      Object.keys(this._data).forEach((elem) => {
        this[elem].active = false;
      });
      this[orderType].active =
        this[orderType].active || !this[orderType].active;
    },
  },
  components: {},
};
</script>
